import {
    makeStyles,
    Typography, useTheme
} from "@material-ui/core";
import React from "react";

const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: theme.spacing(4),
    },
    title: {
        fontWeight: "500",
        position: "relative",
        zIndex: 1,
        "&::after": {
            content: "..",
            position: "absolute",
            left: 0,
            bottom: 0,
            height: "1px",
            width: "60px",
            borderBottom: "1px solid magenta",
        },
    },
    line: {
        height: "3px",
        width: "50px",
        backgroundColor: "#FEB969"
    },
    card: {
        display: "flex",
        minWidth: 309,
        height: 170,
        borderRadius: 17,
        padding: theme.spacing(4),
        paddingTop: theme.spacing(2),
        backgroundColor: theme.palette.primary.main,
        marginTop: theme.spacing(4),
        [theme.breakpoints.up("md")]: {
            marginTop: 0,
        },
        color: "#fff",
        flexDirection: "column",
    },
    body: {
        opacity: 0.7,
    },
    row: {
        display: "flex",
        flexDirection: "row",
        flex: 1,
        marginTop: theme.spacing(2),
    },
    wrapIcon: {
        display: "flex",
        flex: 1,
        alignItems: "flex-end",
    },
}));

export default function AdminTitle(pros) {
    const theme = useTheme();
    const classes = useStyles();

    return (

        <div className={classes.wrapHeader}>
            <Typography
                variant="h6"
                style={{ color: theme.palette.darkIndigo.main }}
            >
                {pros.subTitle}
            </Typography>
            <Typography variant="h4" color="secondary" className={classes.title}>
                {pros.title}
            </Typography>
            <div className={classes.line}></div>
        </div>
    );
}
